import { render } from "./target.vue?vue&type=template&id=446eafff&scoped=true"
import script from "./target.vue?vue&type=script&lang=js"
export * from "./target.vue?vue&type=script&lang=js"

import "./target.vue?vue&type=style&index=0&id=446eafff&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-446eafff"]])

export default __exports__